module.exports = __webpack_public_path__ + "img/GasFee@3x.299367c1.png";